import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=312ddeca&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=312ddeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ddeca",
  null
  
)

export default component.exports